import { Delivery, DateRangeParams } from '../types';
import { getAccessToken } from '../../auth/service/storage.service';
import { mapStatusToArray, API_URL } from '../../common/utils';

/**
 * Obtiene la lista de entregas por rango de fechas
 * @param params Objeto con fechas de inicio y fin
 * @returns Promesa con la lista de entregas
 */
export const getDeliveriesByDateRange = async (params: DateRangeParams): Promise<Delivery[]> => {
  try {
    const token = getAccessToken();
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const requestBody: any = {
      startDate: params.startDate,
      endDate: params.endDate
    };

    // Incluir status en la solicitud solo si está definido
    if (params.status) {
      requestBody.status = mapStatusToArray(params.status) as string[];
    }
    
    const response = await fetch(`${API_URL}/deliveries/date-range`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
      throw new Error(`Error al obtener entregas: ${response.statusText}`);
    }
    
    const data: Delivery[] = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener entregas por rango de fechas:', error);
    throw error;
  }
}; 